var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9295_78601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8976 11.6657C14.9284 14.9886 17.806 16.0944 17.8378 16.1085C17.8135 16.1865 17.3781 17.6844 16.3218 19.2316C15.4087 20.5692 14.4611 21.902 12.9682 21.9296C11.5014 21.9567 11.0297 21.0577 9.35265 21.0577C7.67612 21.0577 7.15206 21.902 5.76351 21.9567C4.32254 22.0113 3.22526 20.5102 2.30459 19.1774C0.423321 16.4513 -1.01436 11.474 0.916082 8.11419C1.87508 6.44571 3.5889 5.38916 5.44908 5.36207C6.86408 5.33502 8.19966 6.31625 9.06467 6.31625C9.92912 6.31625 11.5521 5.13623 13.2584 5.30953C13.9726 5.33933 15.9777 5.59873 17.2651 7.48764C17.1614 7.5521 14.8727 8.88754 14.8976 11.6657ZM12.1408 3.50594C12.9058 2.57776 13.4207 1.28565 13.2803 0C12.1776 0.0444225 10.8441 0.736531 10.0532 1.6642C9.34431 2.4857 8.72352 3.80055 8.89102 5.06075C10.1201 5.15607 11.3758 4.43471 12.1408 3.50594Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9295_78601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8378,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.ef7973bac8b63d700647dfcb469224f0.svg";
export { ForwardRef as ReactComponent };